(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/button/secondary.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/button/secondary.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.payfooter = svs.tur.payfooter || {};
svs.tur.payfooter.button = svs.tur.payfooter.button || {};
svs.tur.payfooter.button.CANCEL = 'Avbryt';
class Secondary extends svs.tur.payfooter.button.Default {
  constructor(_ref) {
    let {
      title = svs.tur.payfooter.button.CANCEL,
      transparent = true,
      outline = true,
      visible = true,
      callback,
      id
    } = _ref;
    super({
      title,
      callback,
      id,
      transparent,
      inverted: !transparent,
      outline,
      visible
    });
    this.log = new svs.core.log.Logger('payfooter:button:secondary');
  }
}
svs.tur.payfooter.button.Secondary = Secondary;

 })(window);